import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const MAX_RECENT_SEARCHES_PER_SECTION = 10;

interface RecentSearchesState {
  termsBySection: Record<string, string[]>;
  addTerm: (section: string, term: string) => void;
  clear: (section: string) => void;
}

/**
 * Client-only history of shop search terms, segmented by section slug — device state,
 * not CMS content, so it persists to localStorage rather than going through the
 * platform data layer.
 */
export const useRecentSearchesStore = create<RecentSearchesState>()(
  persist(
    (set, get) => ({
      termsBySection: {},

      addTerm: (section, term) => {
        const trimmed = term.trim();
        if (!trimmed) return;
        const existing = get().termsBySection[section] ?? [];
        const withoutDuplicate = existing.filter(t => t.toLowerCase() !== trimmed.toLowerCase());
        set({
          termsBySection: {
            ...get().termsBySection,
            [section]: [trimmed, ...withoutDuplicate].slice(0, MAX_RECENT_SEARCHES_PER_SECTION),
          },
        });
      },

      clear: section => {
        set({ termsBySection: { ...get().termsBySection, [section]: [] } });
      },
    }),
    {
      name: 'recent-searches-storage',
    }
  )
);
